import { Game } from "..";

Game.registerEventHandlers({
  tick({ tick }) {
    // Update tick in state (UI already increments and passes it)
    this.state.tick = tick;
    // Process all scheduled events at this tick
    this.executeScheduledEvents(this.state.tick);
    // Clear expired animations
    let clearedAnimations = false;
    for (const item of this.state.items.values()) {
      if (item.animation && item.animation.endTick <= tick) {
        item.animation = undefined;
        clearedAnimations = true;
      }
    }
    if (clearedAnimations && this.merge.checkAll("auto")) return;
    // Per-item charge step: pause-gate, init, auto-spawn match, increment.
    let spawnedItems = false;
    for (const item of this.state.items.values()) {
      if (this.item.tickCharge(item)) spawnedItems = true;
    }
    if (spawnedItems && this.merge.settleBoard()) return;
    // Shade: viscous flow on the parity beat + contact scan.
    this.shade.update(tick);
    // Refresh active drop plan so hover/drag preview reflects new charges.
    this.ui.refreshActivePlan();
  },
});
